import { action, observable, computed } from 'mobx';
import {  Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';

import { ShoppingContextInput } from 'common/__generated__/api';
import { parsePackageType } from 'utils/packageTypeParser';
export interface IMultiItemSearchQuery {
  misId?: string;
  packageType?: string;
}

export class MultiItemStore extends Store {
  @observable
  public misId?: string;

  @observable
  public packageType?: string;

  @observable
  public anchorPriceToken?: string;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setFieldsFromQuery = (query: IMultiItemSearchQuery) => {
    this.misId = query.misId;
    this.packageType = query.packageType;
  };

  @computed
  public get isMultiItem (): boolean {
    return !!(this.misId && this.packageType);
  }

  public getShoppingContext = (): ShoppingContextInput => {
    return this.isMultiItem
      ? {
        multiItem : {
          id          : this.misId,
          packageType : parsePackageType(this.packageType)
        }
      }
      : null;
  };

  public getMultiItemPackageType = () => {
    return this.packageType;
  };

  public isHotelCarPackage = (): boolean => this.isMultiItem && this.packageType === 'hc';
}
